import { render } from "./ItemSelector.vue?vue&type=template&id=6c3fcf77&scoped=true"
import script from "./ItemSelector.vue?vue&type=script&lang=js"
export * from "./ItemSelector.vue?vue&type=script&lang=js"

import "./ItemSelector.vue?vue&type=style&index=0&id=6c3fcf77&scoped=true&lang=css"

import exportComponent from "/home/runner/work/tchutchu/tchutchu/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c3fcf77"]])

export default __exports__